import { render } from "./UpdateAvailableModal.vue?vue&type=template&id=2ff8dad2&scoped=true"
import script from "./UpdateAvailableModal.vue?vue&type=script&lang=js"
export * from "./UpdateAvailableModal.vue?vue&type=script&lang=js"

import "./UpdateAvailableModal.vue?vue&type=style&index=0&id=2ff8dad2&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff8dad2"]])

export default __exports__